// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"642b1a19","667":"286d4f06"}[chunkId] + ".chunk.js";
};